import { FeatureFlags } from 'enums/featureFlags';
import { useFeatureFlag, useFeatureFlagWithReady } from 'hooks/useFeatureFlag';
import { Loader, MaintenancePage } from '@spotted-zebra-uk/ui-components';
import MaintenanceModeWarningBanner from '../../organisms/MaintenanceModeWarningBanner/MaintenanceModeWarningBanner';

export function MaintenanceProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { ready, enabled } = useFeatureFlagWithReady(FeatureFlags.MAINTENANCE);
  const maintenanceModeWarningEnabled = useFeatureFlag(FeatureFlags.MAINTENANCE_MODE_WARNING);

  const handleRefresh = () => {
    window.location.reload();
  };

  if (!ready) {
    return <Loader isPageLoader variant="bubbles" />;
  }

  if (enabled) {
    return <MaintenancePage handleRefresh={handleRefresh} />;
  }

  return <>
    {maintenanceModeWarningEnabled && <MaintenanceModeWarningBanner />}
    {children}</>;
}
